import { i18n, inject, pr, React, RouteComponentProps, ui } from "aaa";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { MessageScreen } from "../../common/MessageScreen";
import { GidSettingsRoutes } from "./GidSettingsRoutes";
import { GidSettingsStore } from "./GidSettingsStore";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
    store: GidSettingsStore;
}

@inject("externalInterfaceStore")
export class GidSettingsLimitSuccess extends React.Component<RouteComponentProps<{}> & IProps> {
    render() {
        return (
            <MessageScreen
                useWebVersion
                variant="success"
                icon={pr.IconMessageOk}
                title={ui.__("gidSettings.limit.success.title")}
                messageComponent={<i18n.FormattedHTMLMessage id="gidSettings.limit.success.message" />}
                buttonLabelId="common.close"
                onDismiss={async () => {
                    await this.props.store.loadData();
                    pushRoute(GidSettingsRoutes.ROOT);
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/loginManagement/gidSettings/GidSettingsLimitSuccess.tsx